module.exports = __webpack_public_path__ + "static/media/Silver.4ba2b0c0.svg";